// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export function log() {
  if (arguments.length > 0) {
    var firstArg = String(arguments.length <= 0 ? undefined : arguments[0]);

    if (firstArg.includes(":error")) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    } else if (firstArg.includes(":warning")) {
      var _console2;

      (_console2 = console).warn.apply(_console2, arguments);
    } else if (firstArg.includes(":info")) {
      var _console3;

      (_console3 = console).info.apply(_console3, arguments);
    } else if (firstArg.includes(":verbose")) {
      var _console4;

      (_console4 = console).debug.apply(_console4, arguments);
    } else {
      var _console5;

      (_console5 = console).debug.apply(_console5, arguments);
    }
  }
}